/*
 * Fritidsmotor: laster menyinnhold med produktbilder forst nar menyen apnes.
 * Hindrer at bilder fra andre produkter ligger i HTML-en pa alle sider
 * (Google valgte feil produktbilde pa grunn av dette).
 * Innholdet hentes via Section Rendering API pa /search, som er blokkert i robots.txt.
 * Stotter bade egen desktop-meny (.fmm-item), temaets megameny (details-mega) og mobilmenyen.
 */
(function () {
  if (window.fmMenuProductsLazy) return;
  window.fmMenuProductsLazy = true;

  var TOKEN = 'fm-menu-products';
  var loading = null;

  function load() {
    if (loading) return loading;

    var placeholders = document.querySelectorAll('[data-menu-products-placeholder]');
    var header = document.querySelector('header[data-section-id]');
    if (!placeholders.length || !header) return Promise.resolve();

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url =
      root + 'search?q=' + TOKEN + '&type=product&section_id=' + encodeURIComponent(header.dataset.sectionId);

    loading = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-menu-products-placeholder]').forEach(function (placeholder) {
          var id = placeholder.getAttribute('data-menu-products-placeholder');
          var fresh = doc.querySelector('[data-menu-products-id="' + id + '"]');
          if (!fresh) return;
          placeholder.insertAdjacentHTML('afterend', fresh.outerHTML);
          placeholder.remove();
        });
        document.querySelectorAll('details[open] menu-product-list').forEach(function (el) {
          if (typeof el.calcNavButtonsPosition === 'function') el.calcNavButtonsPosition();
        });
      })
      .catch(function (err) {
        loading = null;
        console.warn('Kunne ikke laste menyprodukter', err);
      });

    return loading;
  }

  function bind() {
    document.querySelectorAll('.fmm-item, details[is="details-mega"]').forEach(function (menu) {
      ['mouseenter', 'focusin', 'touchstart', 'click'].forEach(function (evt) {
        menu.addEventListener(evt, load, { once: true, passive: true });
      });
    });
    document.querySelectorAll('.menu-drawer-button').forEach(function (btn) {
      btn.addEventListener('click', load, { once: true, passive: true });
    });
    document.addEventListener('menu-drawer:open', load, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();